"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganizations = useOrganizations;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useOrganizations() {
    const organizations = (0, stores_1.useCalculatorStore)((state) => state.data.organizations);
    const baseUrl = (0, stores_1.useCalculatorStore)((state) => state.baseUrl);
    return (0, react_1.useMemo)(() => (0, view_models_1.organizationsViewModel)(organizations, baseUrl), [organizations, baseUrl]);
}
